import api from '../../../utils/api';
import { filenameFromContentDisposition } from '../../../utils/downloadBlob';

/**
 * Map print orders (club boundary prints). v1: club only.
 * Backend: GET/POST /api/maps/print-orders/, POST /api/maps/print-preview/,
 * POST /api/maps/print-pdf/ (queues a job), GET /api/maps/print-jobs/:id/file/
 */
export const mapPrintService = {
  async getOrders() {
    const response = await api.get('/maps/print-orders/');
    return response.data;
  },

  async createOrder(payload) {
    const response = await api.post('/maps/print-orders/', payload);
    return response.data;
  },

  /**
   * Render the print server-side from public-domain USDA/USGS imagery.
   * Returns { image, width, height, acres, effective_dpi, is_native_resolution, attribution }.
   * The first request for an extent fetches imagery and takes several seconds;
   * later requests for the same extent are served from cache.
   */
  async renderPreview(payload, { signal } = {}) {
    const response = await api.post('/maps/print-preview/', payload, { signal });
    return response.data;
  },

  /**
   * Queue a print-ready 300 DPI PDF. Returns immediately with { id, status, detail }.
   * The file is downloaded later from the in-app notification, not from this call.
   */
  async queuePdf(payload, { signal } = {}) {
    const response = await api.post('/maps/print-pdf/', payload, { signal });
    return response.data;
  },

  /**
   * Fetch the stored PDF for a finished job. Does not render again.
   */
  async downloadJob(jobId, { signal } = {}) {
    const response = await api.get(`/maps/print-jobs/${jobId}/file/`, {
      responseType: 'blob',
      signal,
    });
    return {
      blob: response.data,
      filename:
        filenameFromContentDisposition(response.headers?.['content-disposition'])
        || 'club-map.pdf',
    };
  },
};
